import { useSelector } from 'react-redux';
import { Spin } from 'antd';

const LoadingOverlay = () => {
  const { isLoading } = useSelector((state: any) => state.loader);
  return isLoading ? (
    <div className='overlay'>
      <Spin size='large' />
    </div>
  ) : null;
};

export default LoadingOverlay;
